import axiosPost from '../axiosPost';

export const cotizacionesDeMonedasGet = async (arg) => {
    const { params } = arg

    const body = {
        "service": "MonedaSerieGet",
        "params": params ? params : {}
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data.result
    } catch (err) {
        console.log(err)
    }
}